import { Component } from 'react'

import * as h from 'h'

import { siteTitleShorter, indexBody } from 'config'

import Panel from './Panel'
import EmbeddedSearchBar from './EmbeddedSearchBar'

import styles from './styles-panel.scss'

export default class LogoPanel extends Component {
  render () {
    const { onArrowClick } = this.props
    const backgroundImage = 'url(/landingimage/main)'

    return h.h(Panel, { onArrowClick, backgroundImage },
      h.div(h.ca(styles.logoPanelContent),
        h.h1(h.ca(styles.siteTitle), siteTitleShorter),
        h.p(h.ca(styles.tagline), indexBody),
        h.h(EmbeddedSearchBar, {
          pretext: 'Example:'
        })
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/LogoPanel.js